import { RouteRecordRaw } from 'vue-router'

const Catalogs = () =>
  import(/* webpackChunkName: "catalogs-view" */ './pages/index.vue')

const CatalogItems = () =>
  import(/* webpackChunkName: "catalog-items-view" */ './pages/items.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'catalogos',
    name: 'catalogs',
    component: Catalogs,
    meta: {
      title: 'Catálogos',
      auth: {
        requiredPermission: 'catalogs.view',
        requiredModule: 'catalogs',
        requiredCentral: true,
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'catalogos/:ulid/items',
    name: 'catalog-items',
    component: CatalogItems,
    meta: {
      title: 'Ítems de catálogo',
      auth: {
        requiredPermission: 'catalogs.view',
        requiredModule: 'catalogs',
        requiredCentral: true,
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
